import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_GCP_COMPUTE_INSTANCES,
  GET_GCP_COMPUTE_INSTANCES_SUCCESS,
  GET_GCP_COMPUTE_INSTANCES_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  gcpComputeInstancesList: null,
  error: null,
};

export function GCPComputeInstancesStore(state = initialState, action) {
  switch (action.type) {
    case GET_GCP_COMPUTE_INSTANCES:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_GCP_COMPUTE_INSTANCES_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        gcpComputeInstancesList: action.data,
        error: null,
      };
    case GET_GCP_COMPUTE_INSTANCES_ERROR:
      return { ...state, phase: ERROR, error: action.error };
    default:
      return state;
  }
}
